import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import {
  ADD_RESPONSIBLE_PARTIES_REQUEST,
  EDIT_RESPONSIBLE_PARTIES_REQUEST,
  DELETE_RESPONSIBLE_PARTIES_REQUEST,
  LIST_RESPONSIBLE_PARTIES_REQUEST,
} from '../../actions';
import {
  addResponsiblePartiesSuccess,
  addResponsiblePartiesError,
  editResponsiblePartiesSuccess,
  editResponsiblePartiesError,
  deleteResponsiblePartiesSuccess,
  deleteResponsiblePartiesError,
  listResponsiblePartiesSuccess,
  listResponsiblePartiesError,
} from './actions';
import getApiErrors from '../../../helpers/getApiErrors';

function* listResponsiblePartiesByStudentId({ payload }) {
  const { studentId } = payload
  try {
    const response = yield call(api.get, `responsible-parties/students/${studentId}`);
    yield put(listResponsiblePartiesSuccess(response.data.data));
  } catch (error) {
    yield put(listResponsiblePartiesError(error));
  }
}

const addResponsiblePartiesAsync = async (responsibleParties) =>
  api
    .post(`responsible-parties`, {
      ...responsibleParties,
    })
    .then((response) => response)
    .catch((error) => error);

const editResponsiblePartiesAsync = async (responsibleParties) =>
  api
    .put(`responsible-parties/${responsibleParties.id}`, {
      ...responsibleParties,
    })
    .then((response) => response)
    .catch((error) => error);

function* addResponsibleParties({ payload }) {
  try {
    const { responsibleParties } = payload;

    const res = yield call(addResponsiblePartiesAsync, responsibleParties);
    if (!res.response) {
      yield put(addResponsiblePartiesSuccess(res.data.data));
      toast.success('Responsável cadastrado com sucesso');
    } else {
      const errors = res.response.data;
      yield put(addResponsiblePartiesError(errors));
      getApiErrors(errors);
    }
  } catch (error) {
    yield put(addResponsiblePartiesError(error));
    getApiErrors(error);
  }
}

function* editResponsibleParties({ payload }) {
  try {
    const { responsibleParties } = payload;
    const res = yield call(editResponsiblePartiesAsync, responsibleParties);
    if (!res.response) {
      yield put(editResponsiblePartiesSuccess(res.data.data));
      toast.success('Responsável editado com sucesso');
    } else {
      const errors = res.response.data;
      yield put(editResponsiblePartiesError(errors));
      getApiErrors(errors);
    }
  } catch (error) {
    yield put(editResponsiblePartiesError(error));
    getApiErrors(error);
  }
}

const deleteResponsiblePartiesAsync = async (id, studentId) =>
  api
    .delete(`responsible-parties/${id}/students/${studentId}`)
    .then((response) => response)
    .catch((error) => error);

function* deleteResponsibleParties({ payload }) {
  try {
    const { id, studentId } = payload;
    const res = yield call(deleteResponsiblePartiesAsync, id, studentId);
    if (!res.response) {
      toast.success(`Responsável removido com sucesso!`);
      yield put(deleteResponsiblePartiesSuccess(id));
    } else {
      const errors = res.response.data;
      yield put(deleteResponsiblePartiesError(errors));
      getApiErrors(errors);
    }
  } catch (error) {
    yield put(deleteResponsiblePartiesError(error));
    getApiErrors(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_RESPONSIBLE_PARTIES_REQUEST, listResponsiblePartiesByStudentId),
    takeLatest(ADD_RESPONSIBLE_PARTIES_REQUEST, addResponsibleParties),
    takeLatest(EDIT_RESPONSIBLE_PARTIES_REQUEST, editResponsibleParties),
    takeLatest(DELETE_RESPONSIBLE_PARTIES_REQUEST, deleteResponsibleParties),
  ]);
}
